module.exports = __webpack_public_path__ + "img/SalesRevenue.60cbc559.svg";